import Vue from "vue"
Vue.component('k-search-table', {
    props: {
        loading: Boolean,
        rowKey: String,
        get: Function,
        columns: { type: Array, defalut: [] },
    },
    data() {
        return {
            searching: false,
            index: 1,
            size: 10,
            count: 0,
            items: [],
            selectedKeys: [],
        };
    },
    render() {
        const on = { ...this.$listeners }
        const { keys } = this.$listeners
        const { searching, items, index, size, count, selectedKeys } = this.$data
        const { loading, columns, rowKey } = this.$props

        const rowSelection = {
            selectedRowKeys: selectedKeys,
            onChange: keys => {
                this.selectedKeys = keys
                this.$emit('keys', keys)
            }
        }

        const pagination = {
            showQuickJumper: true,
            showSizeChanger: true,
            total: count,
            current: index,
            pageSize: size,
            showTotal: (total) => `显示第 ${index * size - size + 1} 到 ${index * size > count ? count : index * size} 条记录，   共 ${total} 条记录`,
            onShowSizeChange: (i, s) => this.search(0, s),
            onChange: (i, s) => this.search(i, s)
        }

        return (
            <a-table
                on={on}
                rowKey={rowKey}
                loading={loading || searching}
                columns={columns}
                dataSource={items}
                scopedSlots={this.$scopedSlots}
                rowSelection={keys ? rowSelection: null }
                pagination={items.length !== 0 ? pagination : false}
            >
            </a-table>
        )
    },
    mounted() {
        this.search(0)
    },
    methods: {
        /**
         * 查询列表
         * @param {*} index 
         * @param {*} size 
         */
        async search(index, size) {
            const { get } = this
            if (typeof get != "function") {
                console.error("attr get is not function ... ")
                return
            }
            this.searching = true
            this.selectedKeys = []
            this.$emit('keys', [])
            let items = [],
                count = 0;
            if (size && size != this.size) {
                this.size = size;
                this.index = 1;
            } else {
                if (index) this.index = index;
            }
            try {
                const response = await get(this.index, this.size)
                if (response && response.data) {
                    count = response.data.total || 0
                    items = response.data.records || []
                }
            } catch (e) {
                this.$message.error(e || "获取数据失败");
            }
            this.searching = false;
            this.items = items;
            this.count = count;
        },

        /**
         * 删除
         * @param {Function} dropFn 删除函数
         * @param {Boolean} batch 是否是批量
         */
        async remove(dropFn, batch) {
            if (typeof dropFn != 'function')
                return
            try {
                this.$confirm({
                    centered: true,
                    title: batch ? "批量删除" : "删除提示",
                    content: batch ? "确定进行批量删除操作？" : "确定删除该条数据？",
                    onOk: async () => {
                        console.log("onok")
                        try {
                            await dropFn()
                            this.$message.success("删除成功");
                            this.search(0)
                        } catch (e) {
                            this.$message.error(e || "删除记录失败");
                        }
                    }
                });
            } catch (e) {
                this.$message.error(e || "删除记录失败");
            }
        },
        /**
         * 操作后会自动查询，并利用内部searching 
         * @param {*} cb 
         */
        async hook(cb) {
            if (typeof cb != 'function')
                return
            this.searching = true
            try {
                await cb()
                await this.search(0)
                this.$message.success(e.message || "操作成功");
            } catch (error) {
                this.$message.error(e || "操作失败");
            }
            this.searching = false
        }
    },
})